var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4887 10.6734C16.1252 10.6734 16.7356 10.9263 17.1857 11.3764C17.6358 11.8265 17.8887 12.4369 17.8887 13.0734V13.8734C17.8887 17.027 14.9127 20.2734 9.88867 20.2734C4.86467 20.2734 1.88867 17.027 1.88867 13.8734V13.0734C1.88867 12.4369 2.14153 11.8265 2.59162 11.3764C3.0417 10.9263 3.65215 10.6734 4.28867 10.6734H15.4887ZM9.88867 0.273438C11.0556 0.273438 12.1748 0.737008 12.9999 1.56217C13.8251 2.38733 14.2887 3.50648 14.2887 4.67344C14.2887 5.84039 13.8251 6.95955 12.9999 7.78471C12.1748 8.60987 11.0556 9.07344 9.88867 9.07344C8.72172 9.07344 7.60256 8.60987 6.7774 7.78471C5.95224 6.95955 5.48867 5.84039 5.48867 4.67344C5.48867 3.50648 5.95224 2.38733 6.7774 1.56217C7.60256 0.737008 8.72172 0.273438 9.88867 0.273438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconSignup);
export default __webpack_public_path__ + "static/media/buttonIconSignup.c06bcf8ea9f9b8bb622c2a4ea81005ad.svg";
export { ForwardRef as ReactComponent };